export const searchHeader = ({ theme: { colors } }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: `1px solid ${colors.blueGrey1}`,
    padding: '27px 30px 20px',
});
